import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UserBlockAnswers, getGroupPageAnswersMapper, getUserPageAnswersMapper } from 'src/config/api/models/Answers';
import { Exercise } from 'src/config/api/models/Exercise';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { RootState } from 'src/modules/shared/store';

type AddAlgebrakitScoreBody = {
  exerciseId: string;
  sessionId: string;
};

type AlgebrakitSessionResponse = {
  data: {
    sessionId: string;
  };
};

export const exerciseApi = createApi({
  reducerPath: 'exerciseApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.jwt;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    addAlgebrakitScore: builder.mutation<Exercise, AddAlgebrakitScoreBody>({
      query: ({ exerciseId, sessionId }: AddAlgebrakitScoreBody) => ({
        url: apiRoutesV2.algebrakitScore(),
        method: 'POST',
        body: {
          exerciseId,
          sessionId,
        },
      }),
    }),
    getAlgebrakitSessionId: builder.query<AlgebrakitSessionResponse, string>({
      query: (algebrakitId: string) => ({
        url: apiRoutesV2.algebrakit(algebrakitId),
        method: 'GET',
      }),
    }),
    getGroupPageAnswers: builder.query<UserBlockAnswers[], {groupId: string, blockId: string}>({
      query: ({groupId, blockId}) => ({
        url: apiRoutesV2.groupPageAnswers(groupId, blockId),
        method: 'GET',
      }),
      transformResponse: (response: any) => getGroupPageAnswersMapper(response)
    }),
    getUserPageAnswers: builder.query<UserBlockAnswers | undefined, {userId: string, blockId: string}>({
      query: ({userId, blockId}) => ({
        url: apiRoutesV2.userPageAnswers(userId, blockId),
        method: 'GET',
      }),
      transformResponse: (response: any) => getUserPageAnswersMapper(response)
    })
  }),
});

export const { useAddAlgebrakitScoreMutation, useGetAlgebrakitSessionIdQuery, useGetGroupPageAnswersQuery, useGetUserPageAnswersQuery } = exerciseApi;
